export default __webpack_public_path__ + "static/media/Letters3_06.e03872a7.png";